<template>
  <div class="welcome">
    Bok, {{ fullName }}!
    <div>Evo malo statistike!</div>
    <div>Broj aktivnih korisnika: {{ allUsers.length }}</div>
    <div>
      Broj posjetitelja: {{ allUsers.filter(user => user.role === 'Guest' || user.role === 'HonoraryGuest').length }}
    </div>
    <div>
      Broj isprintanih posjetitelja:
      {{ allUsers.filter(user => (user.role === 'Guest' || user.role === 'HonoraryGuest') && user.isPrinted).length }}
    </div>
    <div>Broj sponzora: {{ allUsers.filter(user => user.role === 'Sponsor').length }}</div>
    <div>
      Broj ostvarenih bodova:
      {{ allUsers.map(user => (user.points !== null ? user.points : 0)).reduce((a, b) => a + b, 0) }}
    </div>
    <div class="title">Prijave na radionice:</div>
    <div v-for="(application, index) in workshopApplications" v-bind:key="`${application}-${index}`">
      {{ application }}
    </div>
    <div class="title">Prijave na fly talkove:</div>
    <br /><br />
    <div v-for="(flyTalk, index) in flytalksApplications" v-bind:key="`${flyTalk}-${index}`">
      <span class="page-break">{{ flyTalk.name }}</span
      ><br /><br />
      <div v-for="(eventUser, indexTwo) in flyTalk.eventUsers" v-bind:key="`${eventUser}-${indexTwo}`">
        <div>
          <span>Ime: </span><span>{{ eventUser.user.firstName }}</span>
        </div>
        <div>
          <span>Prezime: </span><span>{{ eventUser.user.lastName }}</span>
        </div>
        <div>
          <span>E mail: </span><span>{{ eventUser.user.email }}</span>
        </div>
        <div>
          <span>Broj mobitela: </span
          ><span>
            {{
              eventUser.user.phoneNumber == null
                ? eventUser.eventApplication && eventUser.eventApplication.phoneNumber
                : eventUser.user.phoneNumber
            }}
          </span>
        </div>
        <div>
          <span>Završeno obrazovanje: </span
          ><span>{{ eventUser.eventApplication && mapEducation(eventUser.eventApplication.levelOfEducation) }}</span>
        </div>
        <div>
          <span>Godine iskustva: </span
          ><span>{{ eventUser.eventApplication && mapExperience(eventUser.eventApplication.workExperience) }}</span>
        </div>
        <div>
          <span>Željena pozicija: </span
          ><span>{{ eventUser.eventApplication && eventUser.eventApplication.wantedPosition }}</span>
        </div>
        <div>
          <span>Hobiji i aktivnosti: </span>
          <span>{{ eventUser.eventApplication && eventUser.eventApplication.hobbiesAndActivities }}</span>
        </div>
        <div>
          <a
            target="_blank"
            v-if="eventUser.eventApplication"
            v-bind:href="`${$API_URL}/${eventUser.eventApplication.cvPath}`"
          >
            CV LINK
          </a>
        </div>
        <br />
      </div>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data() {
    return {
      fullName: '',
      allUsers: [],
      workshopApplications: [],
      flytalksApplications: [],
    };
  },
  methods: {
    mapEducation(enumName) {
      switch (enumName) {
        case 'ElementaryEducation':
          return 'Osnovna škola';
        case 'HighSchoolEducation':
          return 'Srednja škola';
        case 'BachelorsDegree':
          return 'Preddiplomski/stručni studij';
        case 'MastersDegree':
          return 'Diplomski/Specijalistički studij';
        case 'DoctorateDegree':
          return 'Doktorat';
        default:
          break;
      }
    },
    mapExperience(enumName) {
      switch (enumName) {
        case 'None':
          return '0';
        case 'UpToOneYear':
          return '0 - 1';
        case 'OneToTwoYears':
          return '1 - 2';
        case 'TwoToFiveYears':
          return '2 - 5';
        case 'MoreThanFiveYears':
          return '5+';
        default:
          break;
      }
    },
  },
  created() {
    this.fullName = this.$decode(localStorage.getItem('token')).fullname;

    this.$axios.get(`${this.$API_URL}/user/all-users`).then(response => {
      this.allUsers = response.data;
    });

    this.$axios.get(`${this.$API_URL}/user/all-workshop-applications`).then(response => {
      this.workshopApplications = response.data;
    });

    this.$axios.get(`${this.$API_URL}/user/all-fly-talks-applications`).then(response => {
      this.flytalksApplications = response.data;
    });
  },
};
</script>

<style scoped>
.welcome {
  margin-left: 10%;
  color: white;
}

.welcome .title {
  margin-top: 50px;
}

@media print {
  .page-break {
    display: block;
    page-break-before: always;
  }
}
</style>
